import type { OrderBlotterActions } from 'src/store/actions/widgets/orderBlotter';
import type { OrderBlotterWidgetViewModel, WidgetTabViewModel } from 'src/store/types';

export const orderBlotterReducer = (
    state: WidgetTabViewModel<OrderBlotterWidgetViewModel>,
    action: OrderBlotterActions,
): WidgetTabViewModel<OrderBlotterWidgetViewModel> => {
    switch (action.type) {
        case 'updateOrderBlotterAccount': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    accountIds: action.accountIds,
                },
            };
        }

        case 'linkingUpdateOrderBlotterInstrument':
        case 'updateOrderBlotterInstrument': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    instrument: action.instrument,
                },
            };
        }

        default:
            return state;
    }
};
